import { render } from "./addFoodItem.vue?vue&type=template&id=e74556be&scoped=true"
import script from "./addFoodItem.vue?vue&type=script&lang=js"
export * from "./addFoodItem.vue?vue&type=script&lang=js"

import "./addFoodItem.vue?vue&type=style&index=0&id=e74556be&scoped=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e74556be"]])

export default __exports__